import { env } from 'core/constants/env.constants';
import { toBcp47Locale } from 'core/i18n/i18n.utils';
import {
    USER_ASSISTANCE_IP_TOKEN,
    USER_ASSISTANCE_QUERY_PARAMS,
    USER_ASSISTANCE_TOOLTIP_KEYS,
    UserAssistanceQueryParam,
} from './use-user-assistance.constants';

const resolveHost = (template: string, ip: string): string => template.replace(USER_ASSISTANCE_IP_TOKEN, () => ip);

const splitFragment = (address: string): [string, string] => {
    const fragmentStart = address.indexOf('#');
    return fragmentStart === -1 ? [address, ''] : [address.slice(0, fragmentStart), address.slice(fragmentStart)];
};

const withResolvedParams = (address: string, params: Record<UserAssistanceQueryParam, string>): string => {
    const query = Object.entries(params)
        .filter(([, value]) => value)
        .map(([name, value]) => `${name}=${encodeURIComponent(value)}`)
        .join('&');
    if (!query) {
        return address;
    }
    const [location, fragment] = splitFragment(address);
    const separator = location.includes('?') ? '&' : '?';
    return `${location}${separator}${query}${fragment}`;
};

export const buildUserAssistanceUrl = (ip: string, userLanguage: string): string =>
    withResolvedParams(resolveHost(env.VITE_USER_ASSISTANCE_URL, ip), {
        [USER_ASSISTANCE_QUERY_PARAMS.product]: env.VITE_USER_ASSISTANCE_PRODUCT,
        [USER_ASSISTANCE_QUERY_PARAMS.topic]: env.VITE_USER_ASSISTANCE_TOPIC,
        [USER_ASSISTANCE_QUERY_PARAMS.scope]: env.VITE_USER_ASSISTANCE_SCOPE,
        [USER_ASSISTANCE_QUERY_PARAMS.version]: env.VITE_USER_ASSISTANCE_DOC_VERSION,
        [USER_ASSISTANCE_QUERY_PARAMS.language]: toBcp47Locale(userLanguage),
    });

export const buildUserAssistanceCheckUrl = (ip: string): string =>
    resolveHost(env.VITE_USER_ASSISTANCE_CHECK_RESOURCE, ip);

export const toUserAssistanceTooltipKey = (isUserAssistanceAvailable: boolean): string =>
    isUserAssistanceAvailable ? USER_ASSISTANCE_TOOLTIP_KEYS.available : USER_ASSISTANCE_TOOLTIP_KEYS.unavailable;
